export default {
  computed: {
    // A simple chrome detection method.
    isChrome() {
      return !!window.chrome
    }
  }
}
